import { useToast, Box, Text } from "native-base";

type ToastType = "success" | "error" | "warning" | "info";

export function useToastMessage() {
  const toast = useToast();

  const colors = {
    success: { bg: "success.100", border: "success.500", text: "success.700" },
    error: { bg: "error.100", border: "error.500", text: "error.700" },
    warning: { bg: "warning.100", border: "warning.500", text: "warning.700" },
    info: { bg: "info.100", border: "info.500", text: "info.700" },
  };

  function show(type: ToastType, title: string, message: string) {
    const color = colors[type];

    toast.show({
      placement: "bottom",
      duration: 2500,
      render: () => (
        <Box
          bg={color.bg}
          px="4"
          py="3"
          rounded="md"
          borderLeftWidth="4"
          borderLeftColor={color.border}
          shadow="2"
        >
          <Text fontWeight="bold" color={color.text}>
            {title}
          </Text>
          <Text color={color.text}>{message}</Text>
        </Box>
      ),
    });
  }

  return {
    success: (title: string, message: string) =>
      show("success", title, message),
    error: (title: string, message: string) => show("error", title, message),
    warning: (title: string, message: string) =>
      show("warning", title, message),
    info: (title: string, message: string) => show("info", title, message),
  };
}
